import { Box } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useOutletContext } from "react-router-dom";
import {
  fetchPerformers,
  performersSliceSelector,
} from "../../../../redux/features/performersSlice";

const Performers = () => {
  const { organization } = useOutletContext();
  const { id: organizationId } = organization || {};
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { performersFetched, performersOrganizationId } =
    useSelector(performersSliceSelector) || {};

  useEffect(() => {
    if (
      organizationId &&
      (!performersFetched || performersOrganizationId !== organizationId)
    ) {
      dispatch(fetchPerformers({ organizationId }));
    }
  }, [
    dispatch,
    organizationId,
    pathname,
    performersFetched,
    performersOrganizationId,
  ]);

  if (!organization) {
    return null;
  }

  return (
    <Box>
      <Outlet context={{ organization }} />
    </Box>
  );
};

export default Performers;
